export enum jobSortTypeText {
  MAX_PAY_RATE = 'MaxPayRate',
  NEWEST = 'Newest',
  START_DATE = 'StartDate',
}
